import { render } from "./PreseedingZones.vue?vue&type=template&id=2298a843&scoped=true"
import script from "./PreseedingZones.vue?vue&type=script&lang=js"
export * from "./PreseedingZones.vue?vue&type=script&lang=js"

import "./PreseedingZones.vue?vue&type=style&index=0&id=2298a843&scoped=true&lang=css"

import exportComponent from "/Users/habeebrahman/Documents/htdocs/cdz_projects/wg-frontend-v1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2298a843"]])

export default __exports__